export default __webpack_public_path__ + "static/media/ornament_6.998c3807.png";